import { Injectable } from '@angular/core';
import { WrapperService } from '../wrapper/wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class FeedsService {
  constructor(private wrapperService: WrapperService) {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }

  getRequestData(payload:any) {
    const oApiParam = {
      method: 'GET',
      name: 'requests',
      oParam: {
        pgNum: payload.pgNum,
        sortBy: payload.sortBy,
        order: payload.order,
        limit: payload.limit,
        skip: payload.skip,
        feedTypeId: payload.feedTypeId,
      },
      headers: {
        'X-Auth-Token': payload.Cookie,
      },
    };

    if (payload.reqIds) {
      oApiParam.oParam['reqIds'] = payload.reqIds;
    }
    if (payload.statIds) {
      oApiParam.oParam['statIds'] = payload.statIds;
    }
    if (payload.keyword) {
      oApiParam.oParam['q'] = payload.keyword.map((e) => e.text).join(',');
    }
    if (payload.requestedBy) {
      oApiParam.oParam['requestedBy'] = payload.requestedBy;
    }
    if (payload.respondedBy) {
      oApiParam.oParam['respondedBy'] = payload.respondedBy;
    }
    if (payload.agencyPicker) {
      oApiParam.oParam['orgIds'] = payload.agencyPicker.map((e) => e.orgKey).join(','); // need to check with backend team about 'organization_id'
    }
    if (payload.domainIds) {
      oApiParam.oParam['domainIds'] = payload.domainIds;
    }
    return this.wrapperService.call(oApiParam);
  }

  /**
   * Retrieve notification feed data
   * @param typeId - comma separated string containing type ids. e.g. '3,4'
   * @param sortBy - object containing sort configuration (FeedsSortConfiguration from feeds.config.ts)
   * @param order - contains asc or desc order
   * @param pageSize - number representing amount of feeds to return
   * @param pageNum - number representing current page
   * @param filterObj - object containing filter configuration
   */
  getNotificationFeeds(
    typeId: string,
    sortBy: any,
    order: any,
    pageSize: number,
    pageNum: number,
    filterObj: any
  ) {
    let oApiParam = {
      name: 'myFeeds',
      suffix: '/notifications',
      oParam: {
        feedTypeId: typeId,
        sortBy: sortBy,
        order: order,
        limit: pageSize,
        pgNum: pageNum,
      },
      method: 'GET',
    };

    if (filterObj.alertType && filterObj.alertType.length > 0)
      oApiParam.oParam['alertType'] = filterObj.alertType.join(',');

    if (filterObj.domains && filterObj.domains.length > 0)
      oApiParam.oParam['domainIds'] = filterObj.domains.join(',');

    if (filterObj.keyword !== '') oApiParam.oParam['q'] = filterObj.keyword;

    if (filterObj.alertStatus && filterObj.alertStatus.length === 1)
      oApiParam.oParam['alertStatus'] = filterObj.alertStatus[0];

    return this.wrapperService.call(oApiParam);
  }

  getFilters(typeId: string) {
    let oApiParam = {
      name: 'myFeeds',
      suffix: '/filter',
      oParam: {
        typeId: typeId,
      },
      method: 'GET',
    };
    return this.wrapperService.call(oApiParam);
  }
}
